/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { paths } from 'constants';
import { track } from 'utils/koala-analytics';
import { Trans } from 'react-i18next';

const propTypes = {
  address: PropTypes.string,
};

const defaultProps = {
  address: undefined,
};

const trackEditEmail = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > email',
    event_value: 'edit',
  };
  track(trackingData);
};

const Email = props => (
  <section className="details-block email">
    <div className="jg-space-phsm@sm jg-space-phn@lg">
      <div className="jg-text--medium-light">
        <Trans i18nKey="personalDetails.email">Email</Trans>
        <br />
      </div>
      <div className="jg-text--dark">
        <span className="data-value">{props.address}</span>
        <Link
          to={paths.Email}
          onClick={trackEditEmail}
          className="jg-edit-link qa-link__email jg-space-mlsm"
        >
          <Trans i18nKey="personalDetails.edit">Edit</Trans>
        </Link>
      </div>
    </div>
  </section>
);

Email.propTypes = propTypes;

Email.defaultProps = defaultProps;

export default Email;
